import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createAlertSetting = (data) => ({
  type: ActionTypes.ALERT_SETTING_CREATE,
  payload: {
    data,
  },
});

export const updateAlertSetting = (id, data) => ({
  type: ActionTypes.ALERT_SETTING_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteAlertSetting = (id) => ({
  type: ActionTypes.ALERT_SETTING_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createAlertSettingRequested = (data) => ({
  type: ActionTypes.ALERT_SETTING_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createAlertSettingSucceeded = (item) => ({
  type: ActionTypes.ALERT_SETTING_CREATE_SUCCEEDED,
  payload: {
    item,
  },
});

export const createAlertSettingFailed = (error) => ({
  type: ActionTypes.ALERT_SETTING_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createAlertSettingReceived = (alertSetting) => ({
  type: ActionTypes.ALERT_SETTING_CREATE_RECEIVED,
  payload: {
    alertSetting,
  },
});

export const updateAlertSettingRequested = (id, data) => ({
  type: ActionTypes.ALERT_SETTING_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateAlertSettingSucceeded = (alertSetting) => ({
  type: ActionTypes.ALERT_SETTING_UPDATE_SUCCEEDED,
  payload: {
    alertSetting,
  },
});

export const updateAlertSettingFailed = (id, error) => ({
  type: ActionTypes.ALERT_SETTING_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateAlertSettingReceived = (alertSetting) => ({
  type: ActionTypes.ALERT_SETTING_UPDATE_RECEIVED,
  payload: {
    alertSetting,
  },
});

export const deleteAlertSettingRequested = (id) => ({
  type: ActionTypes.ALERT_SETTING_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteAlertSettingSucceeded = (alertSetting) => ({
  type: ActionTypes.ALERT_SETTING_DELETE_SUCCEEDED,
  payload: {
    alertSetting,
  },
});

export const deleteAlertSettingFailed = (id, error) => ({
  type: ActionTypes.ALERT_SETTING_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteAlertSettingReceived = (alertSetting) => ({
  type: ActionTypes.ALERT_SETTING_DELETE_RECEIVED,
  payload: {
    alertSetting,
  },
});
